import React from 'react';
import { Checkbox } from '../forms/Checkbox.jsx';

export function Table({ columns, rows, selectable = false, selected = [], onSelectChange, getRowId = (r) => r.id, stacked = false, onRowClick }) {
  const allChecked = selectable && rows.length > 0 && selected.length === rows.length;
  function toggleAll() {
    onSelectChange && onSelectChange(allChecked ? [] : rows.map(getRowId));
  }
  function toggleRow(id) {
    if (!onSelectChange) return;
    onSelectChange(selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id]);
  }
  const cell = (c, row) => (c.render ? c.render(row) : row[c.key]);

  if (stacked) {
    const [first, ...rest] = columns;
    const last = rest.length > 1 ? rest[rest.length - 1] : null;
    const middle = last ? rest.slice(0, -1) : rest;
    return (
      <div style={{ fontFamily: 'var(--font-body)' }}>
        {rows.map((row, i) => {
          const id = getRowId(row);
          return (
            <div key={id} onClick={onRowClick ? () => onRowClick(row) : undefined} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 14px', minHeight: 64, borderTop: i ? '1px solid var(--border)' : 'none', cursor: onRowClick ? 'pointer' : 'default' }}>
              {selectable && <Checkbox checked={selected.includes(id)} onChange={() => toggleRow(id)} />}
              <div style={{ flex: 1, minWidth: 0, display: 'grid', gap: 2 }}>
                <div style={{ color: 'var(--text-1)', fontSize: 'var(--fs-body-md)' }}>{cell(first, row)}</div>
                {middle.length > 0 && (
                  <div style={{ display: 'flex', flexWrap: 'wrap', columnGap: 10, rowGap: 2, fontSize: 'var(--fs-caption)', color: 'var(--text-muted)' }}>
                    {middle.map((c) => <span key={c.key}>{typeof c.label === 'string' ? c.label + ' ' : ''}<span style={{ color: 'var(--text-2)' }}>{cell(c, row)}</span></span>)}
                  </div>
                )}
              </div>
              {last && <div style={{ flex: 'none' }}>{cell(last, row)}</div>}
            </div>
          );
        })}
      </div>
    );
  }

  return (
    <div style={{ overflowX: 'auto', width: '100%' }}>
    <table style={{ width: '100%', minWidth: '640px', borderCollapse: 'collapse', fontFamily: 'var(--font-body)' }}>
      <thead>
        <tr>
          {selectable && (
            <th style={th(true)}><Checkbox checked={allChecked} indeterminate={!allChecked && selected.length > 0} onChange={toggleAll} /></th>
          )}
          {columns.map((c) => <th key={c.key} style={th()}>{c.label}</th>)}
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => {
          const id = getRowId(row);
          return (
            <tr key={id} onClick={onRowClick ? () => onRowClick(row) : undefined} style={{ borderBottom: '1px solid var(--border)', cursor: onRowClick ? 'pointer' : 'default' }}>
              {selectable && <td style={td()}><Checkbox checked={selected.includes(id)} onChange={() => toggleRow(id)} /></td>}
              {columns.map((c) => <td key={c.key} style={td()}>{cell(c, row)}</td>)}
            </tr>
          );
        })}
      </tbody>
    </table>
    </div>
  );
}

function th(narrow) {
  return { textAlign: 'left', fontSize: 'var(--fs-body-sm)', fontWeight: 500, color: 'var(--text-muted)', padding: '0 20px', height: '44px', background: 'var(--surface-2)', borderBottom: '1px solid var(--border)' };
}
function td() {
  return { padding: '0 20px', height: '58px', whiteSpace: 'nowrap', color: 'var(--text-2)', fontSize: 'var(--fs-body-md)' };
}
